export default __webpack_public_path__ + "static/lefafa_3_3-464a91e42226c11e12ed7964f9f1cacf.webp";